var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "827px",
    height: "50px",
    viewBox: "0 0 827 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 58") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 827,
    height: 50
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(416, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.085239,0 L335.824132,25.0004347 L312.085239,50 L328.003617,50 L351.74164,25.0004347 L328.003617,0 L312.085239,0 Z M337.084804,26.1976386 L338.222017,25.0004347 L337.084804,23.8023614 L316.13417,1.73885827 L327.256777,1.73885827 L349.343755,25.0004347 L327.256777,48.2611417 L316.13417,48.2611417 L337.084804,26.1976386 Z",
    id: "Fill-1",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FF0080",
    points: "338.092733 0 361.830757 25.0004347 338.092733 50 354.011111 50 377.749135 25.0004347 354.011111 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.099445,0 L387.838338,25.0004347 L364.099445,50 L380.017823,50 L403.755847,25.0004347 L380.017823,0 L364.099445,0 Z M389.099011,26.1976386 L390.236224,25.0004347 L389.099011,23.8023614 L368.149246,1.73885827 L379.270984,1.73885827 L401.357961,25.0004347 L379.270984,48.2611417 L368.149246,48.2611417 L389.099011,26.1976386 Z",
    id: "Fill-3",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF0080",
    points: "390.10694 0 413.844963 25.0004347 390.10694 50 406.025318 50 416.113304 39.3747066 429.763341 25.0004347 416.113304 10.6252934 406.025318 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.056826,0 L231.79485,25.0004347 L208.056826,50 L223.975204,50 L247.713227,25.0004347 L223.975204,0 L208.056826,0 Z M233.056391,26.1976386 L234.193604,25.0004347 L233.056391,23.8023614 L212.106627,1.73885827 L223.227495,1.73885827 L245.315342,25.0004347 L223.227495,48.2611417 L212.106627,48.2611417 L233.056391,26.1976386 Z",
    id: "Fill-5",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF0080",
    points: "234.06432 0 257.802344 25.0004347 234.06432 50 249.981829 50 273.720722 25.0004347 249.981829 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.071032,0 L283.809925,25.0004347 L260.071032,50 L275.98941,50 L299.727434,25.0004347 L275.98941,0 L260.071032,0 Z M285.070598,26.1976386 L286.207811,25.0004347 L285.070598,23.8023614 L264.120833,1.73885827 L275.242571,1.73885827 L297.329548,25.0004347 L275.242571,48.2611417 L264.120833,48.2611417 L285.070598,26.1976386 Z",
    id: "Fill-7",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FF0080",
    points: "286.078527 0 309.81655 25.0004347 286.078527 50 301.996035 50 312.084891 39.3747066 325.734928 25.0004347 312.084891 10.6252934 301.996035 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.028413,0 L127.766437,25.0004347 L104.028413,50 L119.946791,50 L143.684815,25.0004347 L119.946791,0 L104.028413,0 Z M129.027978,26.1976386 L130.165192,25.0004347 L129.027978,23.8023614 L108.077344,1.73885827 L119.199951,1.73885827 L141.286929,25.0004347 L119.199951,48.2611417 L108.077344,48.2611417 L129.027978,26.1976386 Z",
    id: "Fill-9",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FF0080",
    points: "130.035907 0 153.773931 25.0004347 130.035907 50 145.953416 50 169.692309 25.0004347 145.953416 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.042619,0 L179.780643,25.0004347 L156.042619,50 L171.960997,50 L195.699021,25.0004347 L171.960997,0 L156.042619,0 Z M181.042185,26.1976386 L182.179398,25.0004347 L181.042185,23.8023614 L160.091551,1.73885827 L171.214158,1.73885827 L193.301135,25.0004347 L171.214158,48.2611417 L160.091551,48.2611417 L181.042185,26.1976386 Z",
    id: "Fill-11",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FF0080",
    points: "182.050114 0 205.788138 25.0004347 182.050114 50 197.967622 50 208.056478 39.3747066 221.706516 25.0004347 208.056478 10.6252934 197.967622 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L23.7380236,25.0004347 L0,50 L15.918378,50 L39.6564016,25.0004347 L15.918378,0 L0,0 Z M24.9995653,26.1976386 L26.1367786,25.0004347 L24.9995653,23.8023614 L4.04893147,1.73885827 L15.1706689,1.73885827 L37.2585161,25.0004347 L15.1706689,48.2611417 L4.04893147,48.2611417 L24.9995653,26.1976386 Z",
    id: "Fill-13",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#FF0080",
    points: "26.0074945 0 49.7455181 25.0004347 26.0074945 50 41.925003 50 65.6638961 25.0004347 41.925003 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0142065,0 L75.7522301,25.0004347 L52.0142065,50 L67.9325845,50 L91.6706081,25.0004347 L67.9325845,0 L52.0142065,0 Z M77.0137718,26.1976386 L78.1509851,25.0004347 L77.0137718,23.8023614 L56.0631379,1.73885827 L67.1857448,1.73885827 L89.2727225,25.0004347 L67.1857448,48.2611417 L56.0631379,48.2611417 L77.0137718,26.1976386 Z",
    id: "Fill-15",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FF0080",
    points: "78.021701 0 101.759725 25.0004347 78.021701 50 93.9392095 50 104.028065 39.3747066 117.678103 25.0004347 104.028065 10.6252934 93.9392095 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.085239,0 L335.824132,25.0004347 L312.085239,50 L328.003617,50 L351.74164,25.0004347 L328.003617,0 L312.085239,0 Z M337.084804,26.1976386 L338.222017,25.0004347 L337.084804,23.8023614 L316.13417,1.73885827 L327.256777,1.73885827 L349.343755,25.0004347 L327.256777,48.2611417 L316.13417,48.2611417 L337.084804,26.1976386 Z",
    id: "Fill-1",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#FF0080",
    points: "338.092733 0 361.830757 25.0004347 338.092733 50 354.011111 50 377.749135 25.0004347 354.011111 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.099445,0 L387.838338,25.0004347 L364.099445,50 L380.017823,50 L403.755847,25.0004347 L380.017823,0 L364.099445,0 Z M389.099011,26.1976386 L390.236224,25.0004347 L389.099011,23.8023614 L368.149246,1.73885827 L379.270984,1.73885827 L401.357961,25.0004347 L379.270984,48.2611417 L368.149246,48.2611417 L389.099011,26.1976386 Z",
    id: "Fill-3",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF0080",
    points: "390.10694 0 413.844963 25.0004347 390.10694 50 406.025318 50 416.113304 39.3747066 429.763341 25.0004347 416.113304 10.6252934 406.025318 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.056826,0 L231.79485,25.0004347 L208.056826,50 L223.975204,50 L247.713227,25.0004347 L223.975204,0 L208.056826,0 Z M233.056391,26.1976386 L234.193604,25.0004347 L233.056391,23.8023614 L212.106627,1.73885827 L223.227495,1.73885827 L245.315342,25.0004347 L223.227495,48.2611417 L212.106627,48.2611417 L233.056391,26.1976386 Z",
    id: "Fill-5",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF0080",
    points: "234.06432 0 257.802344 25.0004347 234.06432 50 249.981829 50 273.720722 25.0004347 249.981829 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.071032,0 L283.809925,25.0004347 L260.071032,50 L275.98941,50 L299.727434,25.0004347 L275.98941,0 L260.071032,0 Z M285.070598,26.1976386 L286.207811,25.0004347 L285.070598,23.8023614 L264.120833,1.73885827 L275.242571,1.73885827 L297.329548,25.0004347 L275.242571,48.2611417 L264.120833,48.2611417 L285.070598,26.1976386 Z",
    id: "Fill-7",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FF0080",
    points: "286.078527 0 309.81655 25.0004347 286.078527 50 301.996035 50 312.084891 39.3747066 325.734928 25.0004347 312.084891 10.6252934 301.996035 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.028413,0 L127.766437,25.0004347 L104.028413,50 L119.946791,50 L143.684815,25.0004347 L119.946791,0 L104.028413,0 Z M129.027978,26.1976386 L130.165192,25.0004347 L129.027978,23.8023614 L108.077344,1.73885827 L119.199951,1.73885827 L141.286929,25.0004347 L119.199951,48.2611417 L108.077344,48.2611417 L129.027978,26.1976386 Z",
    id: "Fill-9",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FF0080",
    points: "130.035907 0 153.773931 25.0004347 130.035907 50 145.953416 50 169.692309 25.0004347 145.953416 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.042619,0 L179.780643,25.0004347 L156.042619,50 L171.960997,50 L195.699021,25.0004347 L171.960997,0 L156.042619,0 Z M181.042185,26.1976386 L182.179398,25.0004347 L181.042185,23.8023614 L160.091551,1.73885827 L171.214158,1.73885827 L193.301135,25.0004347 L171.214158,48.2611417 L160.091551,48.2611417 L181.042185,26.1976386 Z",
    id: "Fill-11",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FF0080",
    points: "182.050114 0 205.788138 25.0004347 182.050114 50 197.967622 50 208.056478 39.3747066 221.706516 25.0004347 208.056478 10.6252934 197.967622 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L23.7380236,25.0004347 L0,50 L15.918378,50 L39.6564016,25.0004347 L15.918378,0 L0,0 Z M24.9995653,26.1976386 L26.1367786,25.0004347 L24.9995653,23.8023614 L4.04893147,1.73885827 L15.1706689,1.73885827 L37.2585161,25.0004347 L15.1706689,48.2611417 L4.04893147,48.2611417 L24.9995653,26.1976386 Z",
    id: "Fill-13",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#FF0080",
    points: "26.0074945 0 49.7455181 25.0004347 26.0074945 50 41.925003 50 65.6638961 25.0004347 41.925003 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0142065,0 L75.7522301,25.0004347 L52.0142065,50 L67.9325845,50 L91.6706081,25.0004347 L67.9325845,0 L52.0142065,0 Z M77.0137718,26.1976386 L78.1509851,25.0004347 L77.0137718,23.8023614 L56.0631379,1.73885827 L67.1857448,1.73885827 L89.2727225,25.0004347 L67.1857448,48.2611417 L56.0631379,48.2611417 L77.0137718,26.1976386 Z",
    id: "Fill-15",
    fill: "#FF0080"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FF0080",
    points: "78.021701 0 101.759725 25.0004347 78.021701 50 93.9392095 50 104.028065 39.3747066 117.678103 25.0004347 104.028065 10.6252934 93.9392095 0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsLeft);
export default __webpack_public_path__ + "static/media/arrows-left.da532cad7a8fbc62373d231d7c3c847f.svg";
export { ForwardRef as ReactComponent };